import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private _searchTerm = new BehaviorSubject<string>('');
  searchTerm$ = this._searchTerm.asObservable();
  searching: string = '';

 get value(): string {
    return this._searchTerm.value;
  }

  set value(val: string) {
    this._searchTerm.next(val);
  }

  clear() {
    this._searchTerm.next('');
  }
}
